import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import GenerateFirstLetterBox from "../../components/generateFirstLetterBox";
import WAITING_LIST from "../../api/services/WAITING_LIST";
import APPOINTMENTS from "../../api/services/APPOINTMENTS";
import styles from "../../styles/_containers/_class/waitingList.module.scss";

const WaitingList = ({ waitlistItems, onDataChange, appointment }) => {
  const [collapsed, setCollapsed] = useState(true);

  // Auto-expand when there are items
  useEffect(() => {
    if (waitlistItems.length > 0) {
      setCollapsed(false);
    } else {
      setCollapsed(true);
    }
  }, [waitlistItems.length]);

  const handleAssignToClass = async (item) => {
    const userId = item.userId?._id || item.userId;
    const userName = item.userId?.name || "הלקוח/ה";

    if (!window.confirm(`לשבץ את ${userName} לשיעור הזה?`)) return;

    const businessId = JSON.parse(localStorage.getItem("user_id"));
    const payload = {
      employeeId: businessId,
      userId,
      serviceId: appointment?.serviceId?._id || appointment?.serviceId,
      businessId,
      date: appointment?.date,
      timeSlot: appointment?.timeSlot,
      cash: true,
    };

    try {
      const res = await APPOINTMENTS.create(payload);
      if (res.data?.code === 200 || res.data?.code === 201) {
        toast.success(`${userName} שובץ/ה לשיעור בהצלחה`);
        try { await WAITING_LIST.remove({ id: item._id }); } catch (e) {}
        onDataChange();
      } else {
        // Backend returned an error (e.g. subscription required)
        const errorMsg = res.data?.message || "שגיאה בשיבוץ";
        const shouldForce = window.confirm(
          `${errorMsg}\n\nהאם לקבוע בכל זאת?`
        );
        if (shouldForce) {
          const forceRes = await APPOINTMENTS.create({
            ...payload,
            isForcedBooking: true,
          });
          if (forceRes.data?.code === 200 || forceRes.data?.code === 201) {
            toast.success(`${userName} שובץ/ה לשיעור בהצלחה`);
            try { await WAITING_LIST.remove({ id: item._id }); } catch (e) {}
            onDataChange();
          } else {
            toast.error(forceRes.data?.message || "שגיאה בשיבוץ");
          }
        }
      }
    } catch (error) {
      console.log(error);
      const errorMsg = error?.response?.data?.message || "";
      if (errorMsg) {
        // Subscription-related backend error
        const shouldForce = window.confirm(
          `${errorMsg}\n\nהאם לקבוע בכל זאת?`
        );
        if (shouldForce) {
          try {
            const forceRes = await APPOINTMENTS.create({
              ...payload,
              isForcedBooking: true,
            });
            if (forceRes.data?.code === 200 || forceRes.data?.code === 201) {
              toast.success(`${userName} שובץ/ה לשיעור בהצלחה`);
              try { await WAITING_LIST.remove({ id: item._id }); } catch (e) {}
              onDataChange();
            } else {
              toast.error(forceRes.data?.message || "שגיאה בשיבוץ");
            }
          } catch (e2) {
            toast.error("שגיאה בשיבוץ לשיעור");
          }
        }
      } else {
        toast.error("שגיאה בשיבוץ לשיעור");
      }
    }
  };

  const handleRemove = async (item) => {
    if (!window.confirm(`להסיר את ${item.userId?.name || "הלקוח/ה"} מרשימת ההמתנה?`))
      return;
    try {
      await WAITING_LIST.remove({ id: item._id });
      toast.success("הוסר/ה מרשימת ההמתנה");
      onDataChange();
    } catch (error) {
      console.log(error);
      toast.error("שגיאה בהסרה מרשימת ההמתנה");
    }
  };

  const getTypeLabel = (item) => {
    if (item.type === "TIME" && item.timeslot) {
      return `זמן (${item.timeslot})`;
    }
    return "יום שלם";
  };

  const count = waitlistItems.length;

  return (
    <div className={styles.container}>
      <div className={styles.header} onClick={() => setCollapsed(!collapsed)}>
        <div className={styles.titleRow}>
          <span className={styles.title}>רשימת המתנה</span>
          <span className={count > 0 ? styles.countActive : styles.countEmpty}>
            {count}
          </span>
        </div>
        <img
          src="/assets/chevron-down.svg"
          alt="toggle"
          className={collapsed ? styles.toggleIconCollapsed : styles.toggleIcon}
        />
      </div>

      {!collapsed && (
        <div className={styles.list}>
          {count === 0 ? (
            <div className={styles.emptyState}>אין ממתינים כרגע</div>
          ) : (
            waitlistItems.map((item) => (
              <div key={item._id} className={styles.row}>
                <div className={styles.clientInfo}>
                  {item.queuePosition && (
                    <span className={styles.positionBadge}>#{item.queuePosition}</span>
                  )}
                  <GenerateFirstLetterBox name={item.userId?.name || "?"} />
                  <div>
                    <h5>{item.userId?.name || "לקוח/ה"}</h5>
                    {item.userId?.phone && (
                      <p className={styles.phone}>{item.userId.phone}</p>
                    )}
                  </div>
                  <span className={styles.typeBadge}>
                    {getTypeLabel(item)}
                  </span>
                </div>
                <div className={styles.rowActions}>
                  <button
                    className={styles.assignBtn}
                    onClick={() => handleAssignToClass(item)}
                  >
                    שבץ לשיעור הזה
                  </button>
                  <button
                    className={styles.removeBtn}
                    onClick={() => handleRemove(item)}
                  >
                    הסרה
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default WaitingList;
